export function Logo({ size = 30 }) {
  return (
    <img
      src="/logo-64.png"
      width={size}
      height={size}
      alt="DMWrapped logo — a gift-wrapped chat bubble"
      className="rounded-[22%]"
    />
  );
}
